// Imports
import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ArrowRight } from "@icons"
import { MockCard } from "@molecules"

export const AudianceCard = ({ title, desc, image, mock, first, subtitle, link }) => {
  const img = getImage(image);

  const handleClick = () => {
    if (link) window.open(link, '_blank');
  };

  if (!mock) {
    return (
      <div
        className={`audience-card
          ${subtitle ? "subtitle" : ""} 
          ${link ? "haslink" : ""}
        `}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <div className="audience-card__top">
          <div className="audience-card__image">
            <GatsbyImage image={img} alt={title} />
          </div>
          <div className="audience-card__top-content">
            <h6>{subtitle}</h6>
            <h5>{title}</h5>
            <p>{desc}</p>
          </div>
        </div>
        {link && (
          <div className="audience-card__bottom">
            <a href="/">
              <span>További részletek</span>
              <ArrowRight />
            </a>
          </div>
        )}
      </div>
    )
  }
  if (mock) {
    return <MockCard className="audiance-card-mock" first={first} />
  }
}
